import { render, staticRenderFns } from "./SubstanceProductCountTableCard.vue?vue&type=template&id=0399e106&"
import script from "./SubstanceProductCountTableCard.vue?vue&type=script&lang=js&"
export * from "./SubstanceProductCountTableCard.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceProductCountTableCard.vue?vue&type=style&index=0&id=0399e106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports